import React, { Component } from "react";
import Link from "gatsby-link";
import { OutboundLink } from 'gatsby-plugin-google-analytics';

const Footer = () => (
    <footer className="site-footer" role="contentinfo">
		<div className="footer-copy">
			<div className="container">
				<div className="row">
					<div className="col-6 col-sm-12">
						<div className="site-credits">© {(new Date()).getFullYear()} TônNguyễn</div>
					</div>
					<div className="col-6 col-sm-12">
						<div className="site-info">
							<OutboundLink href="https://www.gatsbyjs.org/" target="_blank" rel="noopener">Gatsby</OutboundLink>
							<span className="sep"> / </span>
							<OutboundLink href="https://reactjs.org/" target="_blank" rel="noopener">React</OutboundLink>
                            <span className="sep"> / </span>
							<OutboundLink href="https://www.contentful.com/" target="_blank" rel="noopener">Contentful</OutboundLink>
                            <span className="sep"> / </span>
							<OutboundLink href="https://www.netlify.com/" target="_blank" rel="noopener">Netlify</OutboundLink>
						</div>
					</div>
				</div>
			</div>
		</div>		
	</footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/layouts/footer.js